import request from '../utils/user_request'
export function queryRoleList (data) {
  return request({
    url: 'role/search',
    method: 'POST',
    data
  })
}
export function queryRoleData (data) {
  return request({
    url: 'role/get/',
    method: 'GET',
    params: {
      roleId: data
    }
  })
}
export function createNewRole (data) {
  return request({
    url: 'role/create/',
    method: 'POST',
    data
  })
}
export function updateRole (data) {
  return request({
    url: 'role/update/',
    method: 'POST',
    data
  })
}
export function deleteRole (data) {
  return request({
    url: 'role/delete/',
    method: 'GET',
    params: {
      businessRoleId: data
    }
  })
}
export function queryEmployeeList (data) {
  return request({
    url: 'employee/search',
    method: 'POST',
    data
  })
}
export function queryEmployeeData (data) {
  return request({
    url: 'employee/get',
    method: 'GET',
    params: {
      employeeId: data
    }
  })
}
export function getByUniqueAtt (data) {
  return request({
    url: 'employee/getByUniqueAtt',
    method: 'GET',
    params: {
      uniqueAttribute: 'loginName',
      attributeValue: data
    }
  })
}
export function createEmployee (data) {
  return request({
    url: 'employee/create/',
    method: 'POST',
    data
  })
}
export function updateEmployee (data) {
  return request({
    url: 'employee/update/',
    method: 'POST',
    data
  })
}
export function deleteEmployee (data) {
  return request({
    url: 'employee/delete/',
    method: 'GET',
    params: {
      employeeId: data
    }
  })
}
export function disableEmployee (data) {
  return request({
    url: 'employee/disable/',
    method: 'GET',
    params: {
      employeeId: data
    }
  })
}
export function enableEmployee (data) {
  return request({
    url: 'employee/enable/',
    method: 'GET',
    params: {
      employeeId: data
    }
  })
}
export function querySystemTree (data) {
  return request({
    url: 'systemAuth/search',
    method: 'POST',
    data
  })
}
export function findResourceTree (data) {
  return request({
    url: 'resource/accessTenantTree',
    method: 'GET',
    params: {
      authKey: data
    }
  })
}
export function findResourceChildren (data) {
  return request({
    url: 'resource/children',
    method: 'GET',
    params: {
      authKey: data.authKey,
      parentResourceId: data.parentResourceId
    }
  })
}
export function getPublicKey () {
  return request({
    url: 'encryption/getPublicKey',
    method: 'GET'
  })
}
export function getAllRole () {
  return request({
    url: 'role/getAll',
    method: 'GET'
  })
}
export function getAllPosition () {
  return request({
    url: 'position/getAll',
    method: 'GET'
  })
}
export function getPosition (positionId) {
  return request({
    url: '/position/get',
    method: 'GET',
    params: {
      positionId: positionId
    }
  })
}
export function getAllSystem () {
  return request({
    url: 'systemAuth/getPublicKey',
    method: 'GET'
  })
}
export function getTenantSystemAuth () {
  return request({
    url: '/tenant/getTenantSystemAuth',
    method: 'get'
  })
}
export function getTenantTypeSystemAuth (tenantTypeId) {
  return request({
    url: '/tenantType/getTenantTypeSystemAuth',
    method: 'GET',
    params: {
      tenantTypeId: tenantTypeId
    }
  })
}
export function getAccessTenantTypeTree (tenantTypeId, authKey) {
  return request({
    url: '/resource/accessTenantTypeTree',
    method: 'GET',
    params: {
      authKey: authKey,
      tenantTypeId: tenantTypeId
    }
  })
}
export function createTenantTypeRole (data) {
  return request({
    url: '/tenantTypeRole/create',
    method: 'POST',
    data: data
  })
}
export function updateTenantTypeRole (data) {
  return request({
    url: '/tenantTypeRole/update',
    method: 'POST',
    data: data
  })
}
export function getTenantTypeRole (tenantTypeRoleId) {
  return request({
    url: '/tenantTypeRole/get',
    method: 'GET',
    params: {
      tenantTypeRoleId: tenantTypeRoleId
    }
  })
}
export function deleteTenantTypeRole (tenantTypeRoleId) {
  return request({
    url: '/tenantTypeRole/delete',
    method: 'GET',
    params: {
      tenantTypeRoleId: tenantTypeRoleId
    }
  })
}
export function syncUpdateTenantTypeRole (tenantTypeId) {
  return request({
    url: '/tenantType/syncUpdate',
    method: 'POST',
    params: {
      tenantTypeId: tenantTypeId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/roleManage.js